import React from 'react'

const Paragraph = ({paragraphText,className}) => {
  return (
    <div>
                        <p className={ className}>{ paragraphText}</p>
    </div>
  )
}

export default Paragraph
